<script setup lang="ts">
import { computed } from 'vue';
import { IconSocialRatingStar, IconSocialRatingGoogle } from '@icons';
import Icon from '@components/Icon.vue';
import { trans } from '@tools/translation';

/**
 * Any change must be replicated in the frontoffice
 * @see match-frontoffice:templates/components/social-rating.html.twig
 * @see match-search:src/components/SocialRating.vue
 */
const rating = computed<number | null>(() => window.GOOGLE_PLACE_RATING);

const formattedRating = computed<string>((): string => (rating.value === null ? '—' : String(rating.value)));
</script>

<template>
  <div v-if="rating" class="social-rating">
    <span class="social-rating__score">
      <strong>{{ formattedRating }}</strong>{{ trans('social_rating.max_grade') }}
    </span>
    <span class="social-rating__stars" aria-hidden="true">
      <Icon
        v-for="i in 5"
        :key="i"
        :svg="IconSocialRatingStar"
        width="18"
        height="18"
      />
    </span>
    <span class="social-rating__brand" aria-hidden="true" :title="trans('social_rating.source')">
      <Icon :svg="IconSocialRatingGoogle" width="18" height="18" />
    </span>
  </div>
</template>
